import { render, staticRenderFns } from "./addGreenProducts.vue?vue&type=template&id=4a1c8f2d&scoped=true&"
import script from "./addGreenProducts.vue?vue&type=script&lang=js&"
export * from "./addGreenProducts.vue?vue&type=script&lang=js&"
import style0 from "./addGreenProducts.vue?vue&type=style&index=0&id=4a1c8f2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c8f2d",
  null
  
)

export default component.exports